import { Injectable } from '@angular/core'
import { ChtmModel } from './chtm.model'
import { CmodalService } from '../cmodal/cmodal.service'
import { DomSanitizer } from '@angular/platform-browser'
import { PageService } from '../../page/page.service'
import { GlobService } from 'src/app/shared/glob.service'
import { UtilService } from 'src/app/shared/util.service'
import { PipsPipe } from 'src/app/shared/pips.pipe'
import { AlerterService } from 'src/app/shared/alerter.service'
import { AjaxService } from 'src/app/shared/ajax.service'

@Injectable({
  providedIn: 'root'
})
export class ChtmService {
  components: any[]
  thos = this

  // constructor(private pservice: PageService, private cmodalService: CmodalService, private sanitizer: DomSanitizer) { }
  constructor(private glob: GlobService, private util: UtilService, private pservice: PageService, private cmodalService: CmodalService, private sanitizer: DomSanitizer, private pip: PipsPipe, private alerter: AlerterService, private ajax: AjaxService) { }

  async init(thos: any, model: ChtmModel) {
    if (model.sql) this.load(model)
    else {
      let sqls = []
      let ehtm = await this.util.exchange(model.htm, { sqls }, null)
      if (ehtm.err) this.alerter.error(ehtm.err)
      model.shtm = thos.sanitizer.bypassSecurityTrustHtml(ehtm.res)
      setTimeout(async () => {
        if (model.js) await eval("(async () => {" + model.js + "})()")
      }, 3000);
    }
  }

  async load(model: ChtmModel) {
    let thos = this
    this.ajax.execute({
      url: 'chtm/load',
      data: { id: model.id },
      success: async (post: any) => {
        let sqls = post.result
        let ehtm = await this.util.exchange(model.htm, { sqls }, null)
        if (ehtm.err) this.alerter.error(ehtm.err)
        model.shtm = thos.sanitizer.bypassSecurityTrustHtml(ehtm.res)
        
        if (model.js) await eval("(async () => {" + model.js + "})()")
      }
    })
  }
}